import { useRouteError } from "react-router-dom";
import UnauthorizedPage from "../CustomUnauthorized/CustomUnauthorized";

export default function RouteErrorPage() {
  const error = useRouteError();
  console.error("❌ Route Error:", error);

  return (
    <UnauthorizedPage
      leftTitle="Something Went Wrong"
      leftMessage="An unexpected error occurred."
      rightTitle="Unexpected Application Error"
      rightMessage="We're sorry — something went wrong. Our team is working to resolve it. Please refresh the page or try again later. If the problem persists, contact support."
      actions={[
        {
          label: "Reload Page",
          onClick: () => window.location.reload(),
          variant: "filled",
        },
        {
          label: "Go Home",
          href: "/",
          variant: "outline",
        },
      ]}
    />
  );
}
